import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('value-stack');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-16 bg-surface border-y border-gray-200" data-id="element-104">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-105">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6" data-id="element-106">
          <ShieldCheck className="w-10 h-10 text-success" data-id="element-107" />
        </div>

        <h2 className="text-3xl font-heading font-bold text-graphite mb-4" data-id="element-108">
          Garantía de 7 Días: Riesgo Cero
        </h2>

        <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-109">
          Descarga el Kit, lee el eBook, usa los prompts y aplica los guiones.
          Si en 7 días sientes que no te ha dado claridad absoluta sobre cómo
          manejar tus DMs y cerrar más ventas, envíanos un correo y te
          devolvemos el 100% de tu dinero.{' '}
          <strong className="text-graphite" data-id="element-110">
            Sin preguntas, sin resentimientos.
          </strong>
        </p>

        <button onClick={scrollToOffer} className="text-primary font-bold hover:text-blue-700 underline underline-offset-4 transition-colors" data-id="element-111">
          Probar el sistema sin riesgo
        </button>
      </div>
    </section>;
}